import { action } from '@ember/object';

import type { Args as TemplatesTransferedNotificationBaseArgs } from 'webapp/components/templates/transfered-notification/base';
import TemplatesTransferedNotificationBaseComponent from 'webapp/components/templates/transfered-notification/base';

type Action = 'previewTemplate' | 'delete';

export default class TemplatesTransferedNotificationPublicTableRowComponent extends TemplatesTransferedNotificationBaseComponent<TemplatesTransferedNotificationBaseArgs> {
	options: {
		icon: IconName;
		text: string;
		action: string;
		class?: string;
	}[] = [
		{
			icon: 'Databoards',
			text: 'View',
			action: 'previewTemplate',
		},
		{
			class: 'delete',
			icon: 'Trash',
			text: 'Remove',
			action: 'delete',
		},
	];

	@action
	doAction(actionName: string): void {
		this[actionName as Action]();
	}

	@action
	delete() {
		this.handleTransferedObject(false);
	}
}
